import { forwardRef, createElement, Children } from 'react';

const Button = /*#__PURE__*/forwardRef(function Button(props, ref) {
  const {
    disabled,
    target,
    type = 'button',
    ...otherProps
  } = props;
  const Tag = props.href ? 'a' : 'button';
  return createElement(Tag, Object.assign({}, otherProps, {
    "aria-disabled": disabled ? 'true' : undefined,
    disabled: disabled,
    target: Tag === 'a' ? target : undefined,
    type: Tag !== 'a' ? type : undefined,
    ref: ref
  }), Children.count(props.children) > 1 ? Children.map(props.children, child => typeof child === 'string' ? createElement("span", null, child) : child) : props.children);
});

export { Button };
//# sourceMappingURL=Button.js.map
